import { Stack } from 'commons/components';
import { ActiveShippingMethodsCard, FallbackCard } from '../../../components';
import AddressingConfigurationInfoCard from '../AddressingConfiguration';
import CustomShippingCard from '../CustomShippingCard';

function NationalShippingMethods() {
  return (
    <Stack column spacing="loose">
      <ActiveShippingMethodsCard />
      <CustomShippingCard />
      <FallbackCard />
      <AddressingConfigurationInfoCard />
    </Stack>
  );
}

export default NationalShippingMethods;
